// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ivNbS","calendar":"styles_calendar__LrRII","calendar-ru":"styles_calendar-ru__ATKJt","calendar-en":"styles_calendar-en__LBO28"};